// Auto-generated by scripts/bump-version.mjs — do not edit manually.
// This is baked into the bundle at build time and used to detect stale deploys.
export const APP_VERSION = 'CGV3.14';
export const DEPLOYED_AT = '2026-10-14T04:04:39.100Z';
